import React, { useContext, useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";

import { SalesContext } from "../../context/salesContext";
import WorkOrder from "./WorkOrder";
import { Button, ConfirmDialog, DetailModal, EmptyState, Spinner } from "../ui";

const WorkOrderPage = () => {
    const { id } = useParams();
    const history = useHistory();
    const { action } = useContext(SalesContext);

    const [workOrder, setWorkOrder] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [deleteOpen, setDeleteOpen] = useState(false);
    const [deleting, setDeleting] = useState(false);
    const [suppressWorkOrderPageChrome, setSuppressWorkOrderPageChrome] = useState(false);

    const loadWorkOrder = async () => {
        setLoading(true);
        try {
            const data = await action.getSale(id);
            setWorkOrder(data);
            setError(null);
        } catch (err) {
            setError(err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        window.scrollTo(0, 0);
        loadWorkOrder();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    const handleConfirmDelete = async () => {
        setDeleting(true);
        try {
            await action.deleteSale(id);
            history.replace("/work-orders");
        } catch (err) {
            console.error("Error deleting work order:", err);
            setDeleting(false);
        }
    };

    if (loading) {
        return (
            <div className="flex h-[60vh] items-center justify-center">
                <Spinner size="lg" />
            </div>
        );
    }

    if (error || !workOrder) {
        return (
            <EmptyState
                icon={<i className="fas fa-clipboard-list" />}
                title="Work order not found"
                description="This work order may have been deleted or the link is incorrect."
                action={
                    <Button variant="secondary" onClick={() => history.push("/work-orders")}>
                        Back to work orders
                    </Button>
                }
            />
        );
    }

    return (
        <div>
            <div className={suppressWorkOrderPageChrome ? "hidden" : "space-y-4"}>
                <Button
                    variant="ghost"
                    size="sm"
                    onClick={() => history.push("/work-orders")}
                    leadingIcon={<i className="fas fa-arrow-left" aria-hidden="true" />}
                >
                    Back to work orders
                </Button>

                <DetailModal
                    mode="page"
                    title="Work Order Details"
                    actions={
                        <div className="flex w-full justify-center">
                            <Button variant="danger" size="sm" onClick={() => setDeleteOpen(true)}>
                                Delete
                            </Button>
                        </div>
                    }
                >
                    <WorkOrder
                        workOrder={workOrder}
                        setWorkOrder={setWorkOrder}
                        onSpecDoorFullscreenChange={setSuppressWorkOrderPageChrome}
                    />
                </DetailModal>
            </div>

            <ConfirmDialog
                open={deleteOpen}
                title="Delete this work order?"
                description="This action cannot be undone."
                confirmLabel="Delete work order"
                onConfirm={handleConfirmDelete}
                onCancel={() => setDeleteOpen(false)}
                loading={deleting}
            />
        </div>
    );
};

export default WorkOrderPage;
